import graphql from "babel-plugin-relay/macro";

const PortfolioPastTransactionQuery = graphql`
query PortfolioPastTransactionQuery($searchPolitician:String,$first:Int){
     pastTransactionOrderWise(searchPolitician:$searchPolitician,first:$first){
    edges {
       node {
        stock {
            id
          name
          price
          openShare
          totalShare
          lockedShares
          
        }
        orderMode
        quantity
        created
        orderType
        pastTransactionOrderWiseAvgPrice
      }
    }
  }
}
`

export default PortfolioPastTransactionQuery